// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/iq-agency-7me-fileready-nid/js/" + (chunkId === 628 ? "awesome-phonenumber" : chunkId) + "." + {"281":"960c1e5d0b391a5a9c9e","628":"652bf779b2f7d91bbec4"}[chunkId] + ".js";
};